import * as React from "react";
import Typography from "@mui/material/Typography";
import Notifications from "../components/Notifications";
import InnerPage from "../components/InnerPage";

export default function AlertsScreen() {
  return (
    <InnerPage>
     
      <Notifications />
    </InnerPage>
  );
}
